import type { ReactNode } from 'react';

interface HealthRowProps {
  label: string;
  value: ReactNode;
}

// One label/value line. The value never carries status color on its own — a
// green "12 members" says nothing. Colour belongs to the alerts and to the
// badges the panels render inside `value`.
export default function HealthRow({ label, value }: HealthRowProps) {
  return (
    <div className="flex items-baseline justify-between gap-4 py-1.5">
      <span className="shrink-0 text-xs text-muted-foreground">{label}</span>
      <span className="min-w-0 text-right text-sm font-medium tabular-nums">{value}</span>
    </div>
  );
}
